import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Service from '../Service';
import Servicedata from '../Api/service';

function Creditcardservice() {

  return (
    <>

      <Header/>

      <section className="hero-section">
        <div className="container">
          <div className="text-white row align-items-center">
            <h1>Credit Card Service</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Credit Card</span> <span className="link-primary">Service</span>
            </h1>
          </div>
          <div className="row mt-2 align-items-center">
            <div className="col-lg-5 col-md-6">
              <img src="assets/images/svg/crediCard-2.png" className="h-100 p-2 img-fluid" alt />
            </div>
            <div className="col-lg-6 offset-md-1 col-md-5">
              <h3 className="fw-normal mt-3"><b>Sai Financial Service offers</b> a comprehensive range of credit card solutions to meet your financial needs.
                We work with all major banks to provide you with the best credit card offers tailored to your spending habits and lifestyle.</h3>
              {/* <p className="text-muted mt-3">Hyper comes with a variety of ready-to-use applications and pages that help to speed up the development</p> */}
              <div className="mt-4">
                <h2 className="text-secondary">Key Benefits:</h2>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> Multiple Bank Options: We offer credit card services from all leading banks, ensuring that you &nbsp; get the best deal.</p>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> Personalized Recommendations: Based on your spending patterns, we suggest the most suitable credit cards that can maximize your rewards, cashback, or travel benefits.</p>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> Easy Application Process: With Sai Financial Service, applying for a credit card is hassle-free, with minimal paperwork and quick approval times.</p>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> Credit Card Management: We provide support in managing your card, from bill payments to setting up auto-pay features.</p>
              </div>
              <div className="mt-4">
                <h2 className="text-secondary">Our Role:</h2>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> We assist in choosing the right card based on your financial profile.</p>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> End-to-end support during the application process, ensuring smooth communication with banks.</p>
                <p className="text-primary-emphasis d-flex"><i className="mdi mdi-circle-medium text-primary" /> After approval, we help with activation and credit card usage tips.</p>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <h1 style={{ textAlign: 'center' }}>
            <span>Credit Card</span> <span className="link-primary">Service</span>
          </h1>
          
        </div>
      </section>
      
<Servicedata/>
      <Footer />
    </>
  )
}

export default Creditcardservice
